import './event-listings-filter-modal.html.twig';
import './event-listings-filter-modal.scss';

const filters = {
  country: null, // string
  region: null, // string
  search: null, // string
  type: null, // string
  format: [], // string[]
  hidePartners: null,
  dateTo: null, // string e.g 2022-10-15
  dateFrom: null, // string e.g 2022-10-15
};

/**
 * Load in filter data from url params
 */
function initializeFilters() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const entries = urlSearchParams.entries();

  // Url params are kebab case, filters are camel case
  const camelCase = (kebabCase) => {
    const regex = /-(.)/g;
    return kebabCase.replaceAll(regex, (match, p1) => p1.toUpperCase());
  };

  Array.from(entries).forEach(([key, value]) => {
    if(key === "format") {
      filters[camelCase(key)] = value.split(',');
    } else if (key === "hide-partners") {
      filters.hidePartners = true;
    }
    else {
      filters[camelCase(key)] = value;
    }
  });
}

// Update inputs to reflect filters.
// Runs on page load.
function initializeInputs(inputs) {
  inputs.forEach((input) => {
    const inputName = input.name;
    switch (inputName) {
      case 'search':
        if (filters.search) {
          input.value = filters.search;
        }
        return;
      case 'type':
        if (input.dataset.type === filters.type) {
          input.checked = true;
        }
        return;
      case 'format':
        if (filters.format.includes(input.dataset.format)) {
          input.checked = true;
        }
        return;
      case 'hide-partners':
        input.checked = filters.hidePartners;
        return;
      case 'date-to':
        if (filters.dateTo) {
          input.value = filters.dateTo;
        }
        return;
      case 'date-from':
        if (filters.dateFrom) {
          input.value = filters.dateFrom;
        }
        break;
      default:
        break;
    }
  });
}

function updateFilters(inputs) {
  //    Clear filters
  filters.search = null;
  filters.type = null;
  filters.format = [];
  filters.dateTo = null;
  filters.dateFrom = null;

  inputs.forEach((input) => {
    const inputName = input.name;
    switch (inputName) {
      case 'search':
        if (input.value.length > 0) {
          filters.search = input.value.trim();
        }
        return;
      case 'type':
        if (input.checked) {
          filters.type = input.dataset.type;
        }
        return;
      case 'format':
        if (input.checked) {
          filters.format.push(input.dataset.format);
        }
        return;
      case 'hide-partners':
        filters.hidePartners = input.checked;
        return;
      case 'date-to':
        if (input.value.length > 0) {
          filters.dateTo = input.value;
        }
        return;

      case 'date-from':
        if (input.value.length > 0) {
          filters.dateFrom = input.value;
        }
    }
  });

}

function handleClose(modal) {
  // Check for filter alrady in place for country and region
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('country')) {
    if (urlParams.get('country').length > 0) {
      filters.country = urlParams.get('country');
    }
  }

  if (urlParams.has('region')) {
    if (urlParams.get('region').length > 0) {
      filters.region = urlParams.get('region');
    }
  }

  const filterParams = `${filters.country != null ? `&country=${filters.country}` : ''}${
    filters.region != null ? `&region=${filters.region}` : ''
  }${filters.type != null ? `&type=${filters.type}` : ''}${filters.search != null ? `&search=${filters.search}` : ''}${
    filters.format != null && filters.format !== [] ? `&format=${filters.format.join(',')}` : ''
  }${filters.hidePartners === true ? `&hide-partners`: ''}${filters.dateFrom != null ? `&date-from=${filters.dateFrom}` : ''}${
    filters.dateTo != null ? `&date-to=${filters.dateTo}` : ''
  }`;


  if (filterParams.length > 0) {
    window.location.href = window.location.origin + window.location.pathname + filterParams.replace('&', '?');
    return;
  }

  modal.classList.add('event-listings-filter-modal--hidden');

  // Undo setting body to fixed. We did this to avoid users scrolling page while viewing the modal.
  document.body.classList.remove('modal-open');
}

export default function () {
  // Pull in filters from query params
  initializeFilters();

  const el = document.querySelector('.event-listings-filter-modal');
  if (el) {
    el.addEventListener('keydown', (e) => {
      //Esc key
      if (e.keyCode === 27) {
        document.body.classList.remove('modal-open');
        el.classList.add('event-listings-filter-modal--hidden');
        // Move focus back to "More option button"
        document.querySelector(".event-listing-hero__filter-btn").focus();
      }
    });
    const typeRadioItems = el.querySelectorAll('.event-listings-filter-modal__radio-item');
    const typeRadioCheckboxItems = el.querySelectorAll('.event-listings-filter-modal__radio-item, .event-listings-filter-modal__checkbox-item');
    const radioCheckboxClick = (typeItem) => {
      const typeInput = typeItem.querySelector('input');
        if (typeInput) {
          typeInput.click();
        }
    }
    // Click only for radios, checkboxes work just fine
    typeRadioItems.forEach((typeRadioItem) => {
      typeRadioItem.addEventListener('click', (e) => {
        radioCheckboxClick(typeRadioItem);
      });
    });
    typeRadioCheckboxItems.forEach((typeRadioCheckboxItem) => {
      //Trigger click event when enter key 
      typeRadioCheckboxItem.addEventListener('keydown', (e) => {
        if(e.keyCode == 13) {
          radioCheckboxClick(typeRadioCheckboxItem);
        }
      });
    });

    const inputs = el.querySelectorAll('input');
    // Set the inital states for the inputs.
    initializeInputs(inputs);
    inputs.forEach((input) => {
      input.addEventListener('change', () => updateFilters(inputs));
    });

    const closeBtn = el.querySelector('.event-listings-filter-modal__close');
    if (closeBtn) {
      // Push the close button down beyond the admin toolbar.
      const adminToolbar = document.querySelector('#toolbar-administration');
      if (adminToolbar) {
        closeBtn.style.top = '5rem';
      }
      closeBtn.addEventListener('click', () => handleClose(el));
    }

    const searchBtn = el.querySelector('.event-listings-filter-modal__search-button');
    if (searchBtn) {
      searchBtn.addEventListener('click', () => handleClose(el));
    }

    const applyBtn = el.querySelector('.event-listings-filter-modal__apply-button');
    if (applyBtn) {
      applyBtn.addEventListener('click', () => handleClose(el));
    }
  }
}
